import React from 'react';
import { CCard, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CBadge } from '@coreui/react';

const SupportRequestDrafts = ({ drafts }) => {
	if (!drafts || drafts.length === 0) return null;

	return (
		<CCard className="mb-4">
			<CAccordion activeItemKey={1}>
				<CAccordionItem itemKey={1}>
					<CAccordionHeader><strong>Чернетки відповіді</strong></CAccordionHeader>
					<CAccordionBody className="p-3">
						{drafts.map((draft, i) => (
							<div key={draft.id || i} className="mb-3 p-3 border rounded">
								<div className="d-flex gap-2 mb-2">
									{draft.approved
										? <CBadge color="success">Погоджено</CBadge>
										: <CBadge color="secondary">Не погоджено</CBadge>
									}
									{draft.saved_to_qa && <CBadge color="info">В Q&A</CBadge>}
								</div>
								<div style={{ whiteSpace: 'pre-wrap', background: '#f8f9fa', padding: '8px', borderRadius: '4px' }}>
									{draft.draft_text || '—'}
								</div>
							</div>
						))}
					</CAccordionBody>
				</CAccordionItem>
			</CAccordion>
		</CCard>
	);
};

export default SupportRequestDrafts;
